<template>
<div class="percentege-counter">
    <h3 class="m-b-16">Percentage counter</h3>
    <div :class="$prefixClass.row">
        <a-form-model ref="formPercentage" :model="formPercentage" v-bind="layout">
            <a-form-model-item class="m-b-24" label="Font">
                <a-select :prefixCls="$prefixClass.select" v-model="formPercentage.font">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listFonts" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Color">
                <VueColorpicker v-model="formPercentage.color"/>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Size">
                <a-select :prefixCls="$prefixClass.select" v-model="formPercentage.size">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listSize" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="Font weight">
            <a-select :prefixCls="$prefixClass.select" v-model="formPercentage.fontWeight">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listFontWeight" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
        </a-form-model>
    </div>
</div>
</template>

<script>
import { listFontWeight } from './../constant'
import { listSizeText } from './../constant'
import { listFont } from './../constant'

export default {
    name: "PercentageCounter",
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            listFontWeight: listFontWeight,
            listFonts: listFont,
            listSize: listSizeText,
            layout: {
                labelCol: {
                    span: 12
                },
                wrapperCol: {
                    span: 12
                },
            },
        };
    },
    computed: {
        formPercentage: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        formPercentage: {
            handler(form) {
                if ( this.isDisplay ) {
                    this.$emit('runDemo')
                }
            },
            deep: true
        }
    },
    created() {},

    mounted() {},

    methods: {
        submitForm() {
            console.log(this.form)
        }
    },
};
</script>

<style lang="scss">
    .percentege-counter {
    }

</style>
